import React, { useEffect, useState } from 'react';
import { Button, Paper, Snackbar, Stack, Typography } from '@mui/material';
import SalesforcePushDialog from './SalesforcePushDialog';
import { loadSfConfig } from './sfApi';

// sf-popup-fix-v2
// 1. No auto-hide timer on the prompt bar. MUI restarts that timer on mouse-leave
//    even after the bar has closed, which fired "timeout" ~15s later and closed
//    the push form along with it.
// 2. The chosen target is kept in the parent (onChange) and in a module-level
//    fallback, so a re-render or remount of Pre-Leads cannot drop an open form.
let persisted = null;

export default function SalesforcePostCallPrompt({ lead: leadProp, onClose, onChange, apiClient, onPushed }) {
  const [config, setConfig] = useState(null);
  const [, bump] = useState(0);

  useEffect(() => { loadSfConfig(apiClient).then(setConfig); }, [apiClient]);

  if (leadProp) {
    const same = persisted && String(persisted._id) === String(leadProp._id);
    persisted = { ...(same ? persisted : {}), ...leadProp };
  }
  const lead = leadProp || persisted;
  const target = lead ? lead.target || null : null;

  const setTarget = (t) => {
    persisted = lead ? { ...lead, target: t } : null;
    bump((x) => x + 1);
    if (onChange && lead) onChange({ ...lead, target: t });
  };
  const close = () => {
    persisted = null;
    bump((x) => x + 1);
    if (onClose) onClose();
  };

  if (!lead) return null;

  const eligible = Boolean(
    config && config.enabled && config.canPush &&
    (!lead.status || (config.promptStatuses || []).includes(lead.status))
  );

  return (
    <>
      {eligible && !target && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          onClose={(_, reason) => { if (reason === 'escapeKeyDown') close(); }}
        >
          <Paper elevation={6} sx={{ p: 2, maxWidth: 380 }} data-sf="popup-v2">
            <Typography variant="subtitle2" gutterBottom>Call saved. Push to Salesforce?</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              {lead.name || 'This lead'}{lead.status ? ` - ${lead.status}` : ''}
            </Typography>
            <Stack direction="row" spacing={1}>
              <Button size="small" variant="outlined" onClick={() => setTarget('account')}>Account</Button>
              <Button size="small" variant="contained" onClick={() => setTarget('opportunity')}>Opportunity</Button>
              <Button size="small" onClick={close}>Skip</Button>
            </Stack>
          </Paper>
        </Snackbar>
      )}

      <SalesforcePushDialog
        open={Boolean(target)}
        initialTarget={target || 'account'}
        leadId={lead._id}
        apiClient={apiClient}
        onClose={close}
        onPushed={onPushed}
      />
    </>
  );
}
